import React, { useEffect } from 'react';
import { Formik, connect as connectFormik } from 'formik';
import { connect } from 'react-redux';
// [redux -- users]
// import {
//   usersAsValueAndLabelSelectors,
//   usersIsLoadingSelector,
// } from "../../../modules/users/Selectors";
// import { getUserAction, getUsersAction } from "../../../modules/users/Actions";

// [redux -- applicant]

import {
  createApplicantAction,
  updateApplicantAction
} from '../../../modules/applicants/Actions';

// [redux -- artisan categories]
import { getArtisanCategoriesAction } from '../../../modules/artisanJobCategories/Actions';
import { getSupplierCategoriesAction } from '../../../modules/supplierJobCategories/Actions';
import {
  supplierCategoriesAsLabelAndValueSelector,
  supplierCategoriesIsLoadingSelector,
  supplierCategoriesListSelector
} from '../../../modules/supplierJobCategories/Selectors';
import {
  artisanCategoriesAsLabelAndValueSelector,
  artisanCategoriesIsLoadingSelector
} from '../../../modules/artisanJobCategories/Selectors';

import {
  FormGroup,
  InputField,
  Upload,
  TextArea,
  Select,
  SearchableSelect,
  CheckBox,
  FormSectionTitle,
  Separator,
  applicantData
} from '../../../components/form/';

import ArtisanBIOi18n from '../artisans/ArtisanBIOi18n';
import Schema from '../applicants/applicantsSchema';
import setWizardPage from '../../../helpers/setWizardPage';
import { currentUserSelector } from '../../../modules/users/Selectors';
import { globalFail } from '../../../modules/globalFail/Selector';
import WorkingHours from '../../../components/form/WorkingHours';
import { setRedirectFalse } from '../../../modules/globalFail/Action';
import { getUserAction } from '../../../modules/users/Actions';
import { newErrorNotificationAction } from '../../../modules/notifications/Actions';
import { applicantIsLoadingSelector } from '../../../modules/applicants/Selectors';
import { updateAuthApplicantAction } from '../../../modules/auth/Actions';
import { authCurrentDefaultTypeSelecetor } from '../../../modules/auth/Selectors';
import getLangData from '../../../utils/getLangData';
import { MultiInputField } from '../../../components/form';
import SkillsSearchable from '../../../components/form/SkillsSearchable';
// noEducation: 0,
// basicEducation: 1,
// highSchool: 2,
// college: 3,
// masters: 4,

const educationLevel = [
  {
    value: '0',
    label: 'بدون'
  },
  {
    value: '1',
    label: 'تعليم اساسي'
  },
  {
    value: '2',
    label: 'الثانوية العامة / ثانوي فني'
  },
  {
    value: '3',
    label: 'كلية / معهد'
  }
];

const options = [
  {
    value: '0',
    label: 'مورد'
  },
  {
    value: '1',
    label: 'حرفي'
  }
];

const profileLang = getLangData().profile_types;
const fieldsLang = getLangData().fields;
const buttonsLang = getLangData().buttons;

const ArtisansForm = props => {
  // users
  // const { mappedUsers, getUsers, usersIsLodaing } = props;

  // artisans
  const {
    // createArtisan,
    // getArtisan,

    // updateArtisan,
    // artisan,
    // artisanId,
    // artisansIsLoading,
    handleSubmit,
    values,
    page,
    setPage,
    edit,
    redirectFalse,
    createApplicant,
    fail,
    currentUser,
    updateApplicant,
    updateAuthApplicantAction,
    staging,
    userDefaultType
  } = props;

  // categories
  const {
    artisanCategories,
    getArtisanCategories,
    categoriesIsloading,
    getSupplierCategories,
    supplierCategories,
    getSingleUser,
    applicantData,
    reload,
    errorNotification,
    isLoading
  } = props;

  useEffect(() => {
    if (applicantData?.profileType[0] === '1') {
      getArtisanCategories();
    } else {
      getSupplierCategories();
    }

    // getUsers();
    // if (artisanId) {
    //   getArtisan(artisanId);
    //   // console.log(artisan)
    // }
  }, [applicantData]);

  useEffect(() => {
    if (!edit) {
      fail && setWizardPage(page, '6', setPage);
      redirectFalse();
    }
    if (reload) {
      fail && window.location.reload();
    }
  }, [fail]);

  console.log(applicantData, '"applicantData"');
  console.log({ ...Schema().cast(), ...applicantData }, '"applicantData"');
  return (
    <Formik
      validationSchema={Schema(true)}
      enableReinitialize
      initialValues={
        applicantData
          ? {
              ...Schema().cast(),
              ...applicantData,
              skills: applicantData.skills
              ,
              jobCID: applicantData.jobCID
                ? applicantData.jobCID[0]
                : Schema().cast().jobCID
            }
          : Schema().cast()
      }
      onSubmit={async values => {
        // const mappedCID = values.artisanCID;
        // const artisanCID = mappedCID.map((cid) =>
        //   typeof cid === 'object' ? cid._id : cid
        // );

        const { _id } = currentUser;

        const data = {
          ...values,
          skills: values.skills.map(data => data.value)
        };
        if (edit) {
          if (userDefaultType === '0' || userDefaultType === '1') {
            updateApplicant(data._id, {
              ...data,
              artisanCID:
                data.profileType[0] === '1' ? data.artisanCategoryData : [],
              artisanCategoryData:
                data.profileType[0] === '1' ? data.artisanCategoryData : [],
              supplierCID:
                data.profileType[0] === '0' ? data.supplierCategoryData : [],
              supplierCategoryData:
                data.profileType[0] === '0' ? data.supplierCategoryData : []
            });
          } else {
            updateAuthApplicantAction({ applicantID: data._id, ...data });
          }

          // updateArtisan(artisanId, data);
        } else {
          if (staging) {
            createApplicant({ ...data, userID: _id }, false);
          } else {
            createApplicant({ ...data, userID: _id }, true);
          }
          // !fail && setWizardPage(page, '5', setPage);
          // console.log('submit', newPage, [...newPage]);
          getSingleUser(_id);
          reload && window.location.reload();
        }
        // }
      }}
    >
      {({ handleSubmit, values, setFieldValue, errors }) => {
        console.log(values, 'values');
        return (
          <FormGroup
            isLoading={isLoading}
            heading={edit ? buttonsLang.edit : buttonsLang.create}
            handleSubmit={handleSubmit}
            errors={errors}
          >
            {/* {console.log(values)} */}
            <FormSectionTitle>
              {getLangData().tables.basic_info}
            </FormSectionTitle>

            {/* {
         artisan ?( <><InputField name="userData.firstName" label='First Name' disabled/><InputField name="userData.lastName" label='Last Name' disabled/> </> ):<SearchableSelect
          isLoading={usersIsLodaing}
          options={mappedUsers}
          getItems={getUsers}
          name='userID'
          label='User'
          optionLabel={(option) => `Name : ${option.firstName} ${option.lastName} - Email : ${option.email} - Phone : ${option.phone}`}
        />
       }  */}

            {/* <SearchableSelect
         
          options={artisanCategories}
          getItems={getArtisanCategories}
          isLoading={categoriesIsloading}
          name= 'artisanCID'
          label='Artisan Category'
        /> */}

            {/* <InputField name='businessName' label='Business Name'  /> */}
            {/* {console.log(applicantData)} */}
            <Select
              inArray={true}
              options={options}
              name='profileType'
              label={fieldsLang.user_type}
            />

            {values.profileType[0] === '1' && (
              <SearchableSelect
                // isMulti={true}
                options={artisanCategories}
                getItems={getArtisanCategories}
                isLoading={categoriesIsloading}
                name={'jobCID'}
                label={fieldsLang.artisan_category}
              />
            )}
            {values.profileType[0] === '0' && (
              <SearchableSelect
                // inArray={edit ? true : false}
                // isMulti={true}
                options={supplierCategories}
                getItems={getSupplierCategories}
                isLoading={categoriesIsloading}
                name={'jobCID'}
                label={fieldsLang.supplier_category}
              />
            )}

            {/* <Upload
          data={{ customerID: "usads9123213k219d123" }}
          name='logo'
          label={getLangData().fields.logo}
          S3Bucket='warshatna-users'
          API='customer/customer-category-image-signedurl/'
        /> */}

            <TextArea name='applicantBIO' label={fieldsLang.bio_applicant} />
            {/* <ArtisanBIOi18n
              name='applicantBIOi18n'
              description={fieldsLang.bio}
            /> */}
            <SkillsSearchable
              name='skills'
              label={fieldsLang.skills_applicant}
              options={values.skills}
            />

            <Separator />
            <Select
              inArray={true}
              options={educationLevel}
              name={'educationLevel'}
              label={fieldsLang?.education_applicant}
            />
            <InputField
              name='yearsOfExperience'
              type='number'
              label={fieldsLang?.years_applicant}
            />
            <CheckBox
              name='canReallocate'
              label={fieldsLang.reallocate_applicant}
            />

            {/* <SearchableSelectCreatable
              name={'skills'}
              label={fieldsLang.skills_applicant}
              getItems={()=>console.log('ok')}
              options={[{name: 'good', id: '1'}, {name: 'good2', id: '2'}]}
              isLoading={false}
            /> */}
            {/* <FormSectionTitle>Company & Store</FormSectionTitle>
        <CheckBox
          name='onlineStore'
          label='Online Store'
          subLabel='I have Online Store.'
        /> */}
            {/* <CheckBox
          name='offlineStore'
          label='Offline Store'
          subLabel='I have Offline Store.'
        />
        <InputField name='yearEstablished' label='Year Established' />
        <CheckBox
          name='regCompany'
          label='Registered Company'
          subLabel='I have Registered Company.'
        />
        <Select
          options={companySizeOptions}
          name='companySize'
          label='Company Size'
        /> */}
            {
              // Bio
            }
            <Separator />
            {/*  <FormSectionTitle>Contact Person Details</FormSectionTitle>
        <InputField name='contactPerson' label='Contact Person' />
        <InputField name='contactPersonTitle' label='Contact Person Title' />
        <InputField name='contactPersonPhone' label='Contact Person Phone' />
        <InputField name='contactPersonEmail' label='Contact Person Email' />
        <Separator />
        <FormSectionTitle>Social & Online</FormSectionTitle>
        <InputField name='website' label='Website' />
        <InputField name='facebook' label='FaceBook' />
        <InputField name='instagram' label='Instagram' />
        <InputField name='youtube' label='Youtube' />
        <Separator /> */}
            {/* <FormSectionTitle>Working Hours :</FormSectionTitle> */}

            {/* <WorkingHours name='workingHours' /> */}
            {/*   
      <Switch name='workingHours.monday' subLabel={'Mon'} />

*/}
            {/* <Separator />
        <FormSectionTitle>Artisan Status :</FormSectionTitle>
        <CheckBox name='verified' label='Verified' />
        <CheckBox name='trusted' label='Trusted' /> */}
            {/* <CheckBox name='moderated' label='Moderated' /> */}
          </FormGroup>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  // const artisanId = props.match.params.id;
  // const artisanId = 'dumb testing';
  return {
    // users
    currentUser: currentUserSelector(state),
    // mappedUsers: usersAsValueAndLabelSelectors(state),
    // usersIsLodaing: usersIsLoadingSelector(state),
    //artisans
    // artisanId,
    // artisansIsLoading: artisansIsLoadingSelector(state),
    // artisan: artisanByIdSelector(state, artisanId),
    // categories
    fail: globalFail(state),
    artisanCategories: artisanCategoriesAsLabelAndValueSelector(state),
    supplierCategories: supplierCategoriesListSelector(state),
    categoriesIsloading: artisanCategoriesIsLoadingSelector(state),
    isLoading: applicantIsLoadingSelector(state),
    userDefaultType: authCurrentDefaultTypeSelecetor(state)
  };
};

const mapDispatchToProps = {
  createApplicant: createApplicantAction,
  updateApplicant: updateApplicantAction,
  redirectFalse: setRedirectFalse,
  getArtisanCategories: getArtisanCategoriesAction,
  getSupplierCategories: getSupplierCategoriesAction,
  getSingleUser: getUserAction,
  errorNotification: newErrorNotificationAction,
  updateAuthApplicantAction: updateAuthApplicantAction
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectFormik(ArtisansForm));
